import Vue from "vue";
import { getCompany, updateCompany } from "@/api/company";

let autoGenerated; // 后台自动生成的信息，仅在该模块内部更新时使用

export default {
  namespaced: true,
  state: () => ({}),
  mutations: {
    SET_COMPANY(state, payload) {
      Object.keys(payload).forEach(key => {
        Vue.set(state, key, payload[key]);
      });
    }
  },
  actions: {
    async getCompany({ state, commit }) {
      if (state.name === undefined) {
        const { data } = await getCompany();
        data.isDefault ? (autoGenerated = data) : commit("SET_COMPANY", data);
      }
      return { ...state };
    },
    updateCompany({ commit, state }, data) {
      data = { ...autoGenerated, ...state, ...data };
      return updateCompany(data).then(() => {
        commit("SET_COMPANY", data);
      });
    }
  }
};
